<script>
import axios from 'axios'
import {
  SCRIPTS,
  FORM_BUILDER_OPTIONS as formBuilderOptions,
} from '@events/constant'
import isString from 'lodash/isString'

export default {
  props: {
    registrationFormFields: {
      type: [Object, String],
      default: '',
    },
  },
  data: () => ({
    $: null,
    formBuilder: null,
    formBuilderOptions,
    isLoading: true,
    newTemplateName: '',
    saveTemplateVisible: false,
    templates: [],
    templateFields: null,
  }),
  mounted() {
    this.setup()
    this.getTemplates()
  },
  methods: {
    onCloseClick() {
      this.$emit('close')
    },
    onSaveClick() {
      this.$emit('save', this.getFormFields())
      this.$emit('close')
    },
    setup() {
      const self = this
      this.$loadScript(SCRIPTS.jQuery)
        .then(() => this.$loadScript(SCRIPTS.jQueryUI))
        .then(() => {
          self.$ = window.jQuery
          self.$(() => {
            self.$loadScript(SCRIPTS.formBuilder).then(() => {
              self.$(function() {
                self.setupFormBuilder()
              })
            })
          })
        })
        .catch(() => {
          alert('error')
        })
    },
    setDefaultFields() {
      if (!this.registrationFormFields) return

      this.formBuilderOptions.defaultFields = isString(
        this.registrationFormFields
      )
        ? JSON.parse(this.registrationFormFields)
        : this.registrationFormFields
    },
    setupFormBuilder() {
      this.setDefaultFields()

      const self = this

      window
        .jQuery('#form-builder')
        .formBuilder(self.formBuilderOptions)
        .promise.then((formBuilder) => {
          self.formBuilder = formBuilder

          self.isLoading = false

          self
            .$(document)
            .on(
              'change',
              '#form-builder .field-options input.option-label',
              () =>
                self
                  .$(this)
                  .next('.option-value')
                  .val(self.$(this).val())
            )
        })
    },
    editAddedField(lastIndex) {
      try {
        this.$(
          '#fb-editor .form-field.editing .field-actions a[type=edit]'
        ).trigger('click')
      } catch (e) {}

      try {
        this.$(
          `.form-field:nth-last-child(${lastIndex ||
            1}) .field-actions a[type=edit]`
        ).trigger('click')
      } catch (e) {}
    },
    customizeFormDesigner() {
      this.$('#fb-editor .label-wrap>label').html('Header')

      this.$(
        '#fb-editor .text-field .fld-subtype.form-control option[value=color], #fb-editor .text-field .fld-subtype.form-control option[value=password]'
      ).remove()

      this.$('#fb-editor [name=description]').attr(
        'placeholder',
        'This text will appear when the user hovers over the"?" icon'
      )
      this.$('#fb-editor [name=placeholder]').attr(
        'placeholder',
        'This text will display in the field where the user will enter their response'
      )
    },
    addTextField() {
      if (!this.formBuilder) return

      this.formBuilder.actions.addField({
        type: 'text',
        className: 'form-control',
        label: '',
        required: true,
      })

      this.customizeFormDesigner()
      this.editAddedField()
    },

    addDropdownField() {
      if (!this.formBuilder) return

      this.formBuilder.actions.addField({
        type: 'select',
        className: 'form-control',
        label: '',
        required: true,
      })

      this.customizeFormDesigner()
      this.editAddedField()
    },
    addWaiverField() {
      if (!this.formBuilder) return

      this.formBuilder.actions.addField({
        type: 'header',
        subtype: 'h3',
        label: 'Agreement Title',
        className: 'agreement-control',
      })

      this.formBuilder.actions.addField({
        type: 'paragraph',
        label: 'Agreement Content',
        value: 'Enter content here',
        className: 'agreement-control',
      })

      this.formBuilder.actions.addField({
        type: 'checkbox',
        values: [
          {
            label: 'I agree',
            value: 'yes',
          },
        ],
        label: 'Do you agree?',
        required: true,
        className: 'agreement-control',
      })

      this.customizeFormDesigner()
      this.editAddedField(3)
    },
    getFormFields() {
      return this.formBuilder.actions.getData('json')
    },
    getTemplates() {
      axios
        .get('/api/v1/user/formTemplates')
        .then(
          ({ data }) =>
            (this.templates = data.map(({ name, fields: value }) => ({
              name,
              value,
            })))
        )
        .catch(() => alert('Something went wrong.'))
    },
    setTemplateFields() {
      if (!this.templateFields) return

      if (
        window.confirm(
          'Selecting a template would overwrite existing form fields. Are you sure?'
        )
      ) {
        this.formBuilder.actions.setData(this.templateFields)
      } else {
        this.templateFields = null
      }
    },
    onSaveTemplateClick() {
      if (!this.newTemplateName) return

      axios
        .post('/api/v1/user/formTemplates', {
          name: this.newTemplateName,
          fields: this.getFormFields(),
        })
        .then(({ data: { name, fields: value } }) => {
          alert('The template has been successfully saved!')
          this.templates = [...this.templates, { name, value }]
          this.saveTemplateVisible = false
        })
        .catch(() => alert('Something went wrong.'))
    },
  },
}
</script>

<template>
  <BaseModalWindow
    modalcls="w-full max-w-1.95xl bg-white rounded-xl ml-15 px-10 py-8 shadow-box relative left-0"
    :visible="true"
    @close="onCloseClick"
  >
    <template v-slot:body>
      <h3 class="block pb-6 italic font-brandon text-blue-darker text-35xl">
        REGISTRATION FORM
      </h3>

      <span v-if="isLoading">Loading...</span>
      <div v-else class="mb-5 space-y-4">
        <BaseSelectBox
          v-if="templates.length"
          v-model="templateFields"
          :options="templates"
          label="Choose a template:"
          @change="setTemplateFields"
        />

        <div class="flex items-center justify-between">
          <div class="space-x-3">
            <button
              class="button primary-button h-8 leading-relax text-sml rounded-small-button px-3.5"
              @click="addTextField"
            >
              Add Text Field
            </button>
            <button
              class="button primary-button h-8 leading-relax text-sml rounded-small-button px-3.5"
              @click="addDropdownField"
            >
              Add Dropdown
            </button>
            <button
              class="button primary-button h-8 leading-relax text-sml rounded-small-button px-3.5"
              @click="addWaiverField"
            >
              Add Waiver
            </button>
          </div>

          <button
            class="button secondary-button h-8 leading-relax text-sml rounded-small-button px-3.5"
            @click="saveTemplateVisible = true"
          >
            Save as template
          </button>

          <BaseModalWindow
            modalcls="w-full max-w-1.95xl bg-white rounded-xl ml-15 px-10 py-8 shadow-box relative left-0"
            :visible="saveTemplateVisible"
            @close="saveTemplateVisible = false"
          >
            <template v-slot:body>
              <BaseInputText
                v-model="newTemplateName"
                label="Template name:"
                class="my-5"
              />

              <div class="flex items-center justify-end">
                <button
                  class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                  :disabled="!newTemplateName"
                  @click="onSaveTemplateClick"
                >
                  Save
                </button>
                <button
                  class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
                  @click="saveTemplateVisible = false"
                >
                  Cancel
                </button>
              </div>
            </template>
          </BaseModalWindow>
        </div>
      </div>

      <div id="form-builder" />

      <div>
        <button
          class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
          @click="onSaveClick"
        >
          Save
        </button>
        <button
          class="button secondary-button h-7.5 leading-relax text-sml rounded-small-button px-3 mt-3"
          @click="onCloseClick"
        >
          Cancel
        </button>
      </div>
    </template>
  </BaseModalWindow>
</template>

<style lang="scss" scoped>
/* stylelint-disable */
#form-builder::v-deep {
  .cb-wrap.pull-right {
    display: none;
  }
  .form-wrap.form-builder .stage-wrap .frmb {
    min-height: 400px !important;
  }
  .form-wrap.form-builder .stage-wrap.empty::after {
    content: '';
  }
  .form-wrap.form-builder .stage-wrap {
    width: 100%;
  }
  .form-group.className-wrap,
  .form-group.name-wrap,
  .form-group.subtype-wrap,
  .checkbox-field .form-group.field-options,
  .form-wrap.form-builder .frmb li.checkbox-field > .required-asterisk,
  .form-wrap.form-builder .frmb li.checkbox-field > .tooltip-element {
    display: none !important;
  }
  .text-field .form-group.subtype-wrap {
    display: block !important;
  }
  .paragraph-field .agreement-control {
    max-height: 300px;
    overflow: auto;
  }
  .fld-label {
    color: rgb(153, 153, 153);
  }

  /* https://codepen.io/flesler/pen/AEIFc */
  div[contenteditable='true']:empty::before {
    display: block;
    font-style: italic;
    content: 'Enter registration question here';
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    font-style: italic;
  }
  input::placeholder {
    font-style: italic;
  }
  input.option-value {
    display: none;
  }
  .sortable-options input.option-label {
    width: 87% !important;
  }
  .form-wrap.form-builder .form-control {
    height: auto;
    min-height: 34px;
  }
  .formbuilder-checkbox.form-group {
    @apply flex flex-col;

    .checkbox {
      all: unset;
    }

    .formbuilder-checkbox {
      @apply flex items-center gap-3;
    }
  }
}
/* stylelint-enable */
</style>
